const NotFound: React.FC = () => {
  return <h1>Erro 404</h1>;
};

export default NotFound;
